import React from 'react';
interface SectionProps {
  children: ReactNode;
  className?: string;
  id?: string;
  background?: 'primary' | 'secondary' | 'card';
}
export function Section({
  children,
  className = '',
  id,
  background = 'primary'
}: SectionProps) {
  const bgColors = {
    primary: 'bg-[#080c18]',
    secondary: 'bg-[#0d1225]',
    card: 'bg-[#111827]'
  };
  return <section id={id} className={`py-20 px-4 md:px-6 lg:px-8 w-full overflow-hidden ${bgColors[background]} ${className}`} data-id="element-301">
      <div className="max-w-6xl mx-auto relative z-10" data-id="element-302">{children}</div>
    </section>;
}